import { ElMessage } from 'element-plus'
// import '../assets/css/msgBox.css';//可以添加css自定义样式，但是原始样式就很好看了，先不用

// 工具函数：秒转毫秒（处理时间参数）
const secondToMs = (second,defaultMs) => (Number.isFinite(second) ? second * 1000 : defaultMs)

// 弹框1：普通弹框
export const MsgBox = {
    // 参数：msg(必传), duration(秒，默认3秒), showClose(默认显示)
    error: (msg) => ElMessage({
        message: msg,//提示内容
        type: 'error',
        duration: 2000,// 显示时间传入秒转毫秒，不穿默认3秒
        showClose: false,// 是否显示关闭按钮
        grouping: true,// 合并相同消息
        center: true,// 文字居中
        offset: 100,// 距离顶部100px（中间偏上，可根据需求调整）
        customClass: 'msg-box-normal'// 自定义类名，设置弹框css样式 msgBox.css
    }),
    error2: (msg, duration, showClose = true) => ElMessage({
        message: msg,//提示内容
        type: 'error',
        duration: secondToMs(duration,2000),// 显示时间传入秒转毫秒，不穿默认3秒
        showClose: showClose,// 是否显示关闭按钮
        grouping: true,// 合并相同消息
        center: true,// 文字居中
        offset: 100,// 距离顶部100px（中间偏上，可根据需求调整）
        customClass: 'msg-box-normal'// 自定义类名，设置弹框css样式 msgBox.css
    }),
    success: (msg) => ElMessage({
        message: msg,
        type: 'success',
        duration: 2000,
        showClose: true,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    }),
    success2: (msg, duration, showClose = true) => ElMessage({
        message: msg,
        type: 'success',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    }),
    warning: (msg) => ElMessage({
        message: msg,
        type: 'warning',
        duration: 2000,
        showClose: true,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    }),
    warning2: (msg, duration, showClose = true) => ElMessage({
        message: msg,
        type: 'warning',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    }),
    info: (msg) => ElMessage({
        message: msg,
        type: 'info',
        duration: 2000,
        showClose: true,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    }),
    info2: (msg, duration, showClose = true) => ElMessage({
        message: msg,
        type: 'info',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-normal'
    })
}

// 弹框2：带回调的弹框
export const MsgBoxBack = {
    // 扩展：指定类型的带回调弹框
    error: (msg, callback) => ElMessage({
        message: msg,
        type: 'error',
        duration: 2000,
        showClose: false,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    error2: (msg, duration, showClose = false, callback) => ElMessage({
        message: msg,
        type: 'error',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    success: (msg, callback) => ElMessage({
        message: msg,
        type: 'success',
        duration: 2000,
        showClose: false,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    success2: (msg, duration, showClose = false, callback) => ElMessage({
        message: msg,
        type: 'success',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    warning: (msg, callback) => ElMessage({
        message: msg,
        type: 'warning',
        duration: 2000,
        showClose: false,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    warning2: (msg, duration, showClose = false, callback) => ElMessage({
        message: msg,
        type: 'warning',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    info: (msg, callback) => ElMessage({
        message: msg,
        type: 'info',
        duration: 2000,
        showClose: false,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    }),
    info2: (msg, duration, showClose = false, callback) => ElMessage({
        message: msg,
        type: 'info',
        duration: secondToMs(duration,2000),
        showClose: showClose,
        grouping: true,
        center: true,
        offset: 100,
        customClass: 'msg-box-callback',
        onClose: callback || (() => {})
    })
}